import PropTypes from "prop-types";
import { debounce } from "../../../utils/common";
import { CaretDownIcon } from "@phosphor-icons/react";
/**
 * Description placeholder
 * @date 08/04/2024 - 15:34:43
 *
 * @param {{ children: any; index: any; changeActiveIndex: any; activeIndex: any; activeClass: any; inactiveClass: any; styles: any; }} param
 * @param {*} param.children // A react element node
 * @param {*} param.index // Accordion index to be passed to accordion content to render accordion body
 * @param {*} param.changeActiveIndex // Callback function to change active index
 * @param {*} param.activeIndex // Index of the active accordion
 * @param {*} param.activeClass // CSS class name for the active accordion
 * @param {*} param.inactiveClass // CSS class name for the inactive accordion
 * @param {*} param.styles // CSS class name
 * @param {*} param.arrowClasses
 * @returns{React.Component}
 */
const AccordionTitle = ({
  children,
  index,
  changeActiveIndex,
  activeIndex,
  activeClass = "",
  inactiveClass = "",
  styles = "",
  onClickCustomHandler = () => null,
  arrowClasses = "",
}) => {
  /**
   * Description placeholder
   * @date 08/04/2024 - 15:34:43
   *
   * @returns {void} // changes only the active index
   */
  const onClick = debounce(() => {
    if (activeIndex === index) {
      changeActiveIndex(-1);
    } else {
      onClickCustomHandler?.(index);
      changeActiveIndex(index);
    }
  }, 50);

  return (
    <button
      onClick={onClick}
      data-testid="accrodion_title"
      className={`w-full text-left ${index === activeIndex ? activeClass : inactiveClass} ${styles} items-center`}
    >
      {children}
      <div
        className={`transform transition duration-300 ${arrowClasses} ${activeIndex === index ? "-rotate-180" : ""}`}
      >
        <CaretDownIcon size={20} />
      </div>
    </button>
  );
};
AccordionTitle.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  changeActiveIndex: PropTypes.func,
  activeIndex: PropTypes.number,
  activeClass: PropTypes.string,
  inactiveClass: PropTypes.string,
  styles: PropTypes.string,
  onClickCustomHandler: PropTypes.func,
  arrowClasses: PropTypes.string,
};
export default AccordionTitle;
